import { ConfirmFillIcon, RoundIcon } from "@t8891/icon";
import classnames from "classnames";
import React from "react";
import { useState } from "react";
import styles from "./index.module.less";
type IAgreement = React.HTMLProps<HTMLButtonElement> & {
  /** 点击协议回调 */
  onChange?: (value: boolean) => void;
  showMenu?: boolean;
};

const Agreement: React.FC<IAgreement> = (props) => {
  const { onChange, className, showMenu = false } = props;
  const [agencyAgreement, setAgencyAgreement] = useState(false);

  const handleAgencyAgreement = () => {
    const next = !agencyAgreement;
    setAgencyAgreement(next);
    onChange?.(next);
  };
  return (
    <div className={classnames(styles["agreement"], className)} style={{ display: "flex" }}>
      {Boolean(agencyAgreement) ? (
        <ConfirmFillIcon size={14} onClick={handleAgencyAgreement} style={{ marginRight: "6px" }} fill='#3264ff' />
      ) : (
        <RoundIcon size={14} style={{ marginRight: "6px" }} onClick={handleAgencyAgreement} />
      )}
      <p>
        我已仔細閱讀並同意
        <a href={"https://www.8891.com.tw/help-sev.html"} target='_blank'>
          《服務條款》
        </a>
        、
        <a href={"https://www.8891.com.tw/help-article-426.html"} target='_blank'>
          《用戶須知》
        </a>
        、
        <a href={"https://www.8891.com.tw/help-laimer.html"} target='_blank'>
          《免責聲明》
        </a>
        、
        <a href={"https://www.8891.com.tw/help-pris.html"} target='_blank'>
          《隱私權聲明》
        </a>
        、
        <a href={`https://www.8891.com.tw/help-article-442.html`} target='_blank'>
          《一鍵詢價服務說明》
        </a>
        {showMenu && (
          <>
            、
            <a href={`https://www.8891.com.tw/help-article-444.html`} target='_blank'>
              《菜單使用規則》
            </a>
          </>
        )}
        等所載內容；本功能由數字科技與數字廣告共同舉辦，點擊代表您同意將個人資料傳送給您所詢價廠牌對應經銷商等相關廠商。
      </p>
    </div>
  );
};

export default Agreement;
